import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { Card, CardContent } from '@/components/ui/card';
import { Input } from '@/components/ui/input';
import axios from 'axios';
import { toast } from 'sonner';
import { FaPlus, FaTrash, FaSave, FaChevronDown, FaChevronUp } from 'react-icons/fa';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const NewWorkout = () => {
  const navigate = useNavigate();
  const [workoutName, setWorkoutName] = useState('');
  const [workoutDate, setWorkoutDate] = useState(new Date().toISOString().split('T')[0]);
  const [exercises, setExercises] = useState([
    {
      exercise_name: '',
      exercise_category: 'chest',
      expanded: true,
      sets: [
        { set_number: 1, reps: 0, weight: 0, is_warmup: false }
      ]
    }
  ]);
  const [saving, setSaving] = useState(false);
  const [showExercisePicker, setShowExercisePicker] = useState(false);
  const [currentExerciseIndex, setCurrentExerciseIndex] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');

  const exerciseCategories = [
    { value: 'chest', label: 'Pecho' },
    { value: 'back', label: 'Espalda' },
    { value: 'legs', label: 'Piernas' },
    { value: 'shoulders', label: 'Hombros' },
    { value: 'arms', label: 'Brazos' },
    { value: 'core', label: 'Core' }
  ];

  const exerciseLibrary = [
    // PECHO (30+ ejercicios)
    { name: 'Press de Banca Plano', category: 'chest' },
    { name: 'Press de Banca Inclinado', category: 'chest' },
    { name: 'Press de Banca Declinado', category: 'chest' },
    { name: 'Press con Mancuernas Plano', category: 'chest' },
    { name: 'Press con Mancuernas Inclinado', category: 'chest' },
    { name: 'Press con Mancuernas Declinado', category: 'chest' },
    { name: 'Aperturas con Mancuernas Plano', category: 'chest' },
    { name: 'Aperturas con Mancuernas Inclinado', category: 'chest' },
    { name: 'Aperturas en Máquina (Pec Deck)', category: 'chest' },
    { name: 'Aperturas en Polea Baja', category: 'chest' },
    { name: 'Aperturas en Polea Alta', category: 'chest' },
    { name: 'Cruce de Poleas', category: 'chest' },
    { name: 'Fondos en Paralelas (Pecho)', category: 'chest' },
    { name: 'Pullover con Mancuerna', category: 'chest' },
    { name: 'Pullover con Barra', category: 'chest' },
    { name: 'Press en Máquina', category: 'chest' },
    { name: 'Press en Smith Inclinado', category: 'chest' },
    { name: 'Press en Smith Plano', category: 'chest' },
    { name: 'Flexiones (Push-ups)', category: 'chest' },
    { name: 'Flexiones Declinadas', category: 'chest' },
    { name: 'Flexiones con Manos Juntas', category: 'chest' },
    { name: 'Flexiones en Anillas', category: 'chest' },
    
    // ESPALDA (35+ ejercicios)
    { name: 'Dominadas Agarre Pronado', category: 'back' },
    { name: 'Dominadas Agarre Supino', category: 'back' },
    { name: 'Dominadas Agarre Neutral', category: 'back' },
    { name: 'Dominadas Lastradas', category: 'back' },
    { name: 'Peso Muerto Convencional', category: 'back' },
    { name: 'Peso Muerto Rumano', category: 'back' },
    { name: 'Peso Muerto Sumo', category: 'back' },
    { name: 'Peso Muerto con Barra Hexagonal', category: 'back' },
    { name: 'Remo con Barra', category: 'back' },
    { name: 'Remo Pendlay', category: 'back' },
    { name: 'Remo con Mancuerna a Una Mano', category: 'back' },
    { name: 'Remo con Mancuernas', category: 'back' },
    { name: 'Remo en Máquina', category: 'back' },
    { name: 'Remo en Polea Baja', category: 'back' },
    { name: 'Remo en Polea Alta', category: 'back' },
    { name: 'Jalón al Pecho Agarre Ancho', category: 'back' },
    { name: 'Jalón al Pecho Agarre Cerrado', category: 'back' },
    { name: 'Jalón Tras Nuca', category: 'back' },
    { name: 'Pulldown con Cuerda', category: 'back' },
    { name: 'Remo en T', category: 'back' },
    { name: 'Remo Seal Row', category: 'back' },
    { name: 'Face Pull', category: 'back' },
    { name: 'Pullover en Polea', category: 'back' },
    { name: 'Encogimientos con Barra', category: 'back' },
    { name: 'Encogimientos con Mancuernas', category: 'back' },
    { name: 'Encogimientos en Máquina', category: 'back' },
    { name: 'Remo Invertido', category: 'back' },
    { name: 'Hiperextensiones', category: 'back' },
    { name: 'Good Mornings', category: 'back' },
    
    // PIERNAS - SENTADILLAS (31 ejercicios)
    { name: 'Sentadilla con Barra Trasera (Back Squat)', category: 'legs' },
    { name: 'Sentadilla con Barra Frontal (Front Squat)', category: 'legs' },
    { name: 'Sentadilla con Barra Alta', category: 'legs' },
    { name: 'Sentadilla con Barra Baja', category: 'legs' },
    { name: 'Sentadilla con Mancuernas', category: 'legs' },
    { name: 'Sentadilla Goblet', category: 'legs' },
    { name: 'Sentadilla en Multipower (Smith)', category: 'legs' },
    { name: 'Sentadilla en Máquina (Hack)', category: 'legs' },
    { name: 'Sentadilla en Máquina Pendular', category: 'legs' },
    { name: 'Sentadilla Sumo con Barra', category: 'legs' },
    { name: 'Sentadilla Sumo con Mancuerna', category: 'legs' },
    { name: 'Sentadilla Sumo en Multipower', category: 'legs' },
    { name: 'Sentadilla Overhead', category: 'legs' },
    { name: 'Sentadilla Zercher', category: 'legs' },
    { name: 'Sentadilla Box', category: 'legs' },
    { name: 'Sentadilla con Pausa', category: 'legs' },
    { name: 'Sentadilla Tempo', category: 'legs' },
    { name: 'Sentadilla Profunda (ATG)', category: 'legs' },
    { name: 'Sentadilla Parcial', category: 'legs' },
    { name: 'Sentadilla Búlgara con Barra Libre', category: 'legs' },
    { name: 'Sentadilla Búlgara con Mancuernas', category: 'legs' },
    { name: 'Sentadilla Búlgara Goblet', category: 'legs' },
    { name: 'Sentadilla Búlgara en Multipower', category: 'legs' },
    { name: 'Sentadilla Búlgara con Talón Elevado', category: 'legs' },
    { name: 'Sentadilla Búlgara Deficit', category: 'legs' },
    { name: 'Sentadilla Búlgara con Pausa', category: 'legs' },
    { name: 'Sentadilla Búlgara Isométrica', category: 'legs' },
    { name: 'Sentadilla Pistol', category: 'legs' },
    { name: 'Sentadilla Asistida a Una Pierna', category: 'legs' },
    { name: 'Sentadilla a Banco Unilateral', category: 'legs' },
    
    // PIERNAS - ZANCADAS/TIJERAS (15 ejercicios)
    { name: 'Tijeras con Barra', category: 'legs' },
    { name: 'Tijeras con Mancuernas', category: 'legs' },
    { name: 'Tijeras en Multipower', category: 'legs' },
    { name: 'Tijeras Goblet', category: 'legs' },
    { name: 'Zancadas Caminando con Barra', category: 'legs' },
    { name: 'Zancadas Caminando con Mancuernas', category: 'legs' },
    { name: 'Zancadas Alternas en el Sitio', category: 'legs' },
    { name: 'Zancadas hacia Delante', category: 'legs' },
    { name: 'Zancadas hacia Atrás (Reverse Lunge)', category: 'legs' },
    { name: 'Zancadas Laterales', category: 'legs' },
    { name: 'Zancadas Cruzadas (Curtsy Lunge)', category: 'legs' },
    { name: 'Zancadas Deficit', category: 'legs' },
    { name: 'Zancadas con Pausa', category: 'legs' },
    
    // PIERNAS - STEP UP (10 ejercicios)
    { name: 'Step Up con Peso Corporal', category: 'legs' },
    { name: 'Step Up con Mancuernas', category: 'legs' },
    { name: 'Step Up con Barra', category: 'legs' },
    { name: 'Step Up Goblet', category: 'legs' },
    { name: 'Step Up en Multipower', category: 'legs' },
    { name: 'Step Up Lateral', category: 'legs' },
    { name: 'Step Up Alto', category: 'legs' },
    { name: 'Step Up con Rodilla Elevada', category: 'legs' },
    { name: 'Step Up Unilateral Controlado', category: 'legs' },
    { name: 'Step Down (Excéntrico)', category: 'legs' },
    
    // PIERNAS - PRENSA (14 ejercicios)
    { name: 'Prensa Horizontal', category: 'legs' },
    { name: 'Prensa Inclinada', category: 'legs' },
    { name: 'Prensa Vertical', category: 'legs' },
    { name: 'Prensa Pies Juntos', category: 'legs' },
    { name: 'Prensa Pies Abiertos', category: 'legs' },
    { name: 'Prensa Pies Altos', category: 'legs' },
    { name: 'Prensa Pies Bajos', category: 'legs' },
    { name: 'Prensa Sumo', category: 'legs' },
    { name: 'Prensa a Una Pierna', category: 'legs' },
    { name: 'Prensa Alterna Unilateral', category: 'legs' },
    { name: 'Prensa Unilateral Pies Altos', category: 'legs' },
    { name: 'Prensa Unilateral Pies Bajos', category: 'legs' },
    
    // PIERNAS - PESO MUERTO (11 ejercicios)
    { name: 'Peso Muerto Convencional', category: 'legs' },
    { name: 'Peso Muerto Sumo', category: 'legs' },
    { name: 'Peso Muerto Rumano', category: 'legs' },
    { name: 'Peso Muerto Piernas Rígidas', category: 'legs' },
    { name: 'Peso Muerto con Mancuernas', category: 'legs' },
    { name: 'Peso Muerto en Multipower', category: 'legs' },
    { name: 'Peso Muerto Trap Bar', category: 'legs' },
    { name: 'Peso Muerto Deficit', category: 'legs' },
    { name: 'Peso Muerto con Pausa', category: 'legs' },
    { name: 'Peso Muerto Unilateral', category: 'legs' },
    { name: 'Peso Muerto Rumano Unilateral', category: 'legs' },
    
    // PIERNAS - GLÚTEO (11 ejercicios)
    { name: 'Hip Thrust con Barra', category: 'legs' },
    { name: 'Hip Thrust con Mancuerna', category: 'legs' },
    { name: 'Hip Thrust en Multipower', category: 'legs' },
    { name: 'Hip Thrust Unilateral', category: 'legs' },
    { name: 'Glute Bridge con Barra', category: 'legs' },
    { name: 'Glute Bridge Unilateral', category: 'legs' },
    { name: 'Pull-Through en Polea', category: 'legs' },
    { name: 'Kickback en Polea', category: 'legs' },
    { name: 'Kickback con Banda', category: 'legs' },
    { name: 'Frog Pumps', category: 'legs' },
    { name: 'Patada de Glúteo en Máquina', category: 'legs' },
    
    // PIERNAS - FEMORAL (8 ejercicios)
    { name: 'Curl Femoral Tumbado', category: 'legs' },
    { name: 'Curl Femoral Sentado', category: 'legs' },
    { name: 'Curl Femoral de Pie', category: 'legs' },
    { name: 'Curl Femoral Unilateral', category: 'legs' },
    { name: 'Curl Nórdico', category: 'legs' },
    { name: 'Good Morning con Barra', category: 'legs' },
    { name: 'Good Morning en Multipower', category: 'legs' },
    { name: 'Buenos Días con Banda', category: 'legs' },
    
    // PIERNAS - CUÁDRICEPS (5 ejercicios)
    { name: 'Extensión de Piernas Bilateral', category: 'legs' },
    { name: 'Extensión de Piernas Unilateral', category: 'legs' },
    { name: 'Extensión con Pausa', category: 'legs' },
    { name: 'Sissy Squat', category: 'legs' },
    { name: 'Spanish Squat', category: 'legs' },
    
    // PIERNAS - ABDUCTORES/ADUCTORES (11 ejercicios)
    { name: 'Abducción en Máquina', category: 'legs' },
    { name: 'Abducción en Polea', category: 'legs' },
    { name: 'Abducción con Banda de Pie', category: 'legs' },
    { name: 'Abducción con Banda Sentado', category: 'legs' },
    { name: 'Caminata Lateral con Banda', category: 'legs' },
    { name: 'Monster Walk', category: 'legs' },
    { name: 'Aducción en Máquina', category: 'legs' },
    { name: 'Aducción en Polea', category: 'legs' },
    { name: 'Aducción con Banda', category: 'legs' },
    { name: 'Copenhagen Plank', category: 'legs' },
    
    // PIERNAS - GEMELOS (6 ejercicios)
    { name: 'Elevación de Talones de Pie', category: 'legs' },
    { name: 'Elevación de Talones Sentado', category: 'legs' },
    { name: 'Elevación de Talones en Prensa', category: 'legs' },
    { name: 'Elevación de Talones Unilateral', category: 'legs' },
    { name: 'Elevación de Talones en Multipower', category: 'legs' },
    { name: 'Donkey Calf Raises', category: 'legs' },
    
    // PIERNAS - POTENCIA (7 ejercicios)
    { name: 'Sentadilla con Salto', category: 'legs' },
    { name: 'Zancada con Salto', category: 'legs' },
    { name: 'Step Up Pliométrico', category: 'legs' },
    { name: 'Broad Jump', category: 'legs' },
    { name: 'Box Jump', category: 'legs' },
    { name: 'Arranque con Barra (Clean)', category: 'legs' },
    { name: 'Kettlebell Swing', category: 'legs' },
    
    // HOMBROS (30+ ejercicios)
    { name: 'Press Militar con Barra', category: 'shoulders' },
    { name: 'Press con Mancuernas Sentado', category: 'shoulders' },
    { name: 'Press con Mancuernas de Pie', category: 'shoulders' },
    { name: 'Press Arnold', category: 'shoulders' },
    { name: 'Press en Máquina', category: 'shoulders' },
    { name: 'Press Bradford', category: 'shoulders' },
    { name: 'Press Landmine', category: 'shoulders' },
    { name: 'Elevaciones Laterales con Mancuernas', category: 'shoulders' },
    { name: 'Elevaciones Laterales en Polea', category: 'shoulders' },
    { name: 'Elevaciones Laterales en Máquina', category: 'shoulders' },
    { name: 'Elevaciones Laterales Inclinado', category: 'shoulders' },
    { name: 'Elevaciones Frontales con Mancuernas', category: 'shoulders' },
    { name: 'Elevaciones Frontales con Barra', category: 'shoulders' },
    { name: 'Elevaciones Frontales con Disco', category: 'shoulders' },
    { name: 'Pájaros con Mancuernas', category: 'shoulders' },
    { name: 'Pájaros en Máquina', category: 'shoulders' },
    { name: 'Pájaros en Polea', category: 'shoulders' },
    { name: 'Remo al Mentón con Barra', category: 'shoulders' },
    { name: 'Remo al Mentón con Mancuernas', category: 'shoulders' },
    { name: 'Face Pull', category: 'shoulders' },
    { name: 'Encogimientos con Barra', category: 'shoulders' },
    { name: 'Encogimientos con Mancuernas', category: 'shoulders' },
    { name: 'Parada de Manos (Handstand)', category: 'shoulders' },
    { name: 'Pike Push-ups', category: 'shoulders' },
    
    // BRAZOS - BÍCEPS (25+ ejercicios)
    { name: 'Curl con Barra Z', category: 'arms' },
    { name: 'Curl con Barra Recta', category: 'arms' },
    { name: 'Curl con Mancuernas', category: 'arms' },
    { name: 'Curl Martillo', category: 'arms' },
    { name: 'Curl Concentrado', category: 'arms' },
    { name: 'Curl Predicador con Barra', category: 'arms' },
    { name: 'Curl Predicador con Mancuernas', category: 'arms' },
    { name: 'Curl en Banco Inclinado', category: 'arms' },
    { name: 'Curl en Polea Baja', category: 'arms' },
    { name: 'Curl en Polea Alta', category: 'arms' },
    { name: 'Curl 21s', category: 'arms' },
    { name: 'Curl Araña', category: 'arms' },
    { name: 'Curl Inverso', category: 'arms' },
    { name: 'Curl de Muñeca', category: 'arms' },
    { name: 'Dominadas Supinas', category: 'arms' },
    
    // BRAZOS - TRÍCEPS (25+ ejercicios)
    { name: 'Press Francés con Barra', category: 'arms' },
    { name: 'Press Francés con Mancuernas', category: 'arms' },
    { name: 'Press Francés con Barra Z', category: 'arms' },
    { name: 'Extensiones sobre la Cabeza con Mancuerna', category: 'arms' },
    { name: 'Extensiones sobre la Cabeza con Cuerda', category: 'arms' },
    { name: 'Extensiones en Polea Alta', category: 'arms' },
    { name: 'Extensiones en Polea con Cuerda', category: 'arms' },
    { name: 'Extensiones a Una Mano en Polea', category: 'arms' },
    { name: 'Patada de Tríceps', category: 'arms' },
    { name: 'Fondos para Tríceps', category: 'arms' },
    { name: 'Fondos en Banco', category: 'arms' },
    { name: 'Press Cerrado en Banco', category: 'arms' },
    { name: 'Crush Press', category: 'arms' },
    { name: 'Skull Crushers', category: 'arms' },
    
    // CORE/ABDOMEN (30+ ejercicios)
    { name: 'Plancha', category: 'core' },
    { name: 'Plancha Lateral', category: 'core' },
    { name: 'Plancha con Elevación de Pierna', category: 'core' },
    { name: 'Crunches', category: 'core' },
    { name: 'Crunches Inversos', category: 'core' },
    { name: 'Crunches en Polea', category: 'core' },
    { name: 'Elevación de Piernas Colgado', category: 'core' },
    { name: 'Elevación de Piernas en Banco', category: 'core' },
    { name: 'Elevación de Rodillas', category: 'core' },
    { name: 'Russian Twist', category: 'core' },
    { name: 'Russian Twist con Peso', category: 'core' },
    { name: 'Mountain Climbers', category: 'core' },
    { name: 'Dead Bug', category: 'core' },
    { name: 'Bird Dog', category: 'core' },
    { name: 'Ab Wheel Rollout', category: 'core' },
    { name: 'Bicicleta', category: 'core' },
    { name: 'V-Ups', category: 'core' },
    { name: 'Sit-ups', category: 'core' },
    { name: 'Sit-ups Declinado', category: 'core' },
    { name: 'Hollow Body Hold', category: 'core' },
    { name: 'L-Sit', category: 'core' },
    { name: 'Dragon Flag', category: 'core' },
    { name: 'Pallof Press', category: 'core' },
    { name: 'Woodchoppers', category: 'core' },
    { name: 'Plancha con Balón', category: 'core' },
    { name: 'Toe Touches', category: 'core' }
  ];

  const toggleExercise = (index) => {
    const newExercises = [...exercises];
    newExercises[index].expanded = !newExercises[index].expanded;
    setExercises(newExercises);
  };

  const openExercisePicker = (index) => {
    setCurrentExerciseIndex(index);
    setShowExercisePicker(true);
    setSearchTerm('');
  };

  const selectExercise = (exerciseName) => {
    if (currentExerciseIndex !== null) {
      updateExercise(currentExerciseIndex, 'exercise_name', exerciseName);
      setShowExercisePicker(false);
      setCurrentExerciseIndex(null);
    }
  };

  // Función para normalizar texto (remover tildes y convertir a minúsculas)
  const normalizeText = (text) => {
    return text
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '');
  };

  const filteredExercises = exerciseLibrary.filter(ex => {
    const normalizedExerciseName = normalizeText(ex.name);
    const normalizedSearchTerm = normalizeText(searchTerm);
    return normalizedExerciseName.includes(normalizedSearchTerm);
  });

  const addExercise = () => {
    setExercises([...exercises, {
      exercise_name: '',
      exercise_category: 'chest',
      expanded: true,
      sets: [{ set_number: 1, reps: 0, weight: 0, is_warmup: false }]
    }]);
  };

  const removeExercise = (index) => {
    setExercises(exercises.filter((_, i) => i !== index));
  };

  const addSet = (exerciseIndex) => {
    const newExercises = [...exercises];
    const currentSets = newExercises[exerciseIndex].sets;
    newExercises[exerciseIndex].sets = [...currentSets, {
      set_number: currentSets.length + 1,
      reps: 0,
      weight: 0,
      is_warmup: false
    }];
    setExercises(newExercises);
  };

  const removeSet = (exerciseIndex, setIndex) => {
    const newExercises = [...exercises];
    newExercises[exerciseIndex].sets = newExercises[exerciseIndex].sets.filter((_, i) => i !== setIndex);
    newExercises[exerciseIndex].sets = newExercises[exerciseIndex].sets.map((set, i) => ({
      ...set,
      set_number: i + 1
    }));
    setExercises(newExercises);
  };

  const updateExercise = (index, field, value) => {
    const newExercises = [...exercises];
    newExercises[index][field] = value;
    setExercises(newExercises);
  };

  const updateSet = (exerciseIndex, setIndex, field, value) => {
    const newExercises = [...exercises];
    newExercises[exerciseIndex].sets[setIndex][field] = value;
    setExercises(newExercises);
  };

  const calculateTotalVolume = () => {
    let total = 0;
    exercises.forEach(exercise => {
      exercise.sets.forEach(set => {
        if (!set.is_warmup) {
          total += (parseFloat(set.reps) || 0) * (parseFloat(set.weight) || 0);
        }
      });
    });
    return total;
  };

  const handleSave = async () => {
    if (!workoutName.trim()) {
      toast.error('Ingresa un nombre para el entrenamiento');
      return;
    }

    if (exercises.length === 0 || exercises[0].exercise_name.trim() === '') {
      toast.error('Agrega al menos un ejercicio');
      return;
    }

    setSaving(true);
    try {
      const processedExercises = exercises.map(ex => ({
        exercise_name: ex.exercise_name,
        exercise_category: ex.exercise_category,
        sets: ex.sets,
        total_volume: ex.sets.reduce((sum, set) => 
          !set.is_warmup ? sum + (parseFloat(set.reps) || 0) * (parseFloat(set.weight) || 0) : sum, 0
        )
      }));

      const workoutData = {
        workout_name: workoutName,
        workout_date: new Date(workoutDate).toISOString(),
        exercises: processedExercises,
        total_volume: calculateTotalVolume()
      };

      await axios.post(`${API}/workouts`, workoutData, { withCredentials: false });
      toast.success('✅ Entrenamiento registrado');
      navigate('/data-progresion');
    } catch (error) {
      console.error('Error saving workout:', error);
      toast.error('Error al guardar');
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="min-h-screen" style={{ backgroundColor: '#0a0a0a' }}>
      {/* Header */}
      <div className="text-white py-6 px-6 shadow-md" style={{ background: 'linear-gradient(135deg, var(--brand-primary), #00F0FF)' }}>
        <div className="max-w-5xl mx-auto">
          <h1 className="text-3xl font-poppins font-bold mb-1 uppercase">Nuevo Entreno</h1>
          <p className="text-white/90 text-sm">Registra tus ejercicios y series</p>
        </div>
      </div>

      <div className="max-w-5xl mx-auto px-6 py-8">
        {/* Basic Info */}
        <div className="mb-6 p-6 rounded-2xl" style={{ backgroundColor: 'rgba(255,255,255,0.05)', border: '1px solid rgba(255,255,255,0.1)' }}>
          <div className="grid md:grid-cols-2 gap-4">
            <div>
              <label className="block text-sm font-medium text-white mb-2">Nombre del Workout</label>
              <Input
                value={workoutName}
                onChange={(e) => setWorkoutName(e.target.value)}
                placeholder="ej: Push Day"
                className="bg-white/10 border-white/20 text-white placeholder:text-gray-500"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-white mb-2">Fecha</label>
              <Input
                type="date"
                value={workoutDate}
                onChange={(e) => setWorkoutDate(e.target.value)}
                className="bg-white/10 border-white/20 text-white"
              />
            </div>
          </div>
        </div>

        {/* Exercises */}
        <div className="space-y-4 mb-6">
          {exercises.map((exercise, exIndex) => (
            <Card key={exIndex} style={{ backgroundColor: 'rgba(255,255,255,0.05)', border: '1px solid rgba(255,255,255,0.1)' }}>
              {/* Exercise Header */}
              <div 
                className="flex items-center justify-between p-4 border-b"
                style={{ backgroundColor: 'rgba(255,255,255,0.03)', borderColor: 'rgba(255,255,255,0.1)' }}
              >
                <div className="flex items-center gap-3 flex-1">
                  <button
                    onClick={() => toggleExercise(exIndex)}
                    className="text-gray-400 hover:text-white transition-colors"
                  >
                    {exercise.expanded ? <FaChevronUp /> : <FaChevronDown />}
                  </button>
                  <button
                    onClick={() => openExercisePicker(exIndex)}
                    className="flex-1 text-left font-poppins font-semibold text-white hover:text-[var(--brand-primary)] transition-colors"
                  >
                    {exercise.exercise_name || 'Selecciona un ejercicio'}
                  </button>
                </div>
                <Button
                  variant="ghost"
                  size="sm"
                  onClick={(e) => {
                    e.stopPropagation();
                    removeExercise(exIndex);
                  }}
                  disabled={exercises.length === 1}
                  className="text-gray-400 hover:text-red-500"
                >
                  <FaTrash />
                </Button>
              </div>

              {/* Exercise Content */}
              {exercise.expanded && (
                <CardContent className="p-4" style={{ backgroundColor: 'transparent' }}>
                  {/* Sets Table */}
                  <div className="mb-4">
                    <div className="grid grid-cols-[60px_1fr_1fr_80px_60px] gap-2 mb-2 text-xs font-medium text-gray-400 px-2">
                      <div>SET</div>
                      <div>REPS</div>
                      <div>PESO (kg)</div>
                      <div>WARM-UP</div>
                      <div></div>
                    </div>
                    {exercise.sets.map((set, setIndex) => (
                      <div key={setIndex} className="grid grid-cols-[60px_1fr_1fr_80px_60px] gap-2 items-center mb-2">
                        <div className="text-center font-semibold text-white">{set.set_number}</div>
                        <Input
                          type="number"
                          value={set.reps || ''}
                          onChange={(e) => updateSet(exIndex, setIndex, 'reps', e.target.value)}
                          className="text-center bg-white/10 border-white/20 text-white placeholder:text-gray-500"
                          placeholder="0"
                        />
                        <Input
                          type="number"
                          step="0.5"
                          value={set.weight || ''}
                          onChange={(e) => updateSet(exIndex, setIndex, 'weight', e.target.value)}
                          className="text-center bg-white/10 border-white/20 text-white placeholder:text-gray-500"
                          placeholder="0"
                        />
                        <div className="flex justify-center">
                          <input
                            type="checkbox"
                            checked={set.is_warmup}
                            onChange={(e) => updateSet(exIndex, setIndex, 'is_warmup', e.target.checked)}
                            className="w-5 h-5 accent-[var(--brand-primary)]"
                          />
                        </div>
                        <Button
                          variant="ghost"
                          size="sm"
                          onClick={() => removeSet(exIndex, setIndex)}
                          disabled={exercise.sets.length === 1}
                          className="text-gray-400 hover:text-red-500"
                        >
                          <FaTrash />
                        </Button>
                      </div>
                    ))}
                  </div>
                  <Button
                    onClick={() => addSet(exIndex)}
                    variant="outline"
                    size="sm"
                    className="w-full border-[var(--brand-primary)] text-[var(--brand-primary)] hover:bg-[var(--brand-primary)]/10"
                  >
                    <FaPlus className="mr-2" /> Agregar Serie
                  </Button>
                </CardContent>
              )}
            </Card>
          ))}
        </div>

        {/* Add Exercise Button */}
        <Button
          onClick={addExercise}
          className="w-full mb-6 text-white py-6 font-bold rounded-full"
          style={{ background: 'linear-gradient(135deg, var(--brand-primary), #00F0FF)' }}
        >
          <FaPlus className="mr-2" /> Agregar Ejercicio
        </Button>

        {/* Actions */}
        <div className="flex gap-3">
          <Button
            variant="outline"
            onClick={() => navigate('/data-progresion')}
            className="flex-1 border-[var(--brand-primary)] text-[var(--brand-primary)] hover:bg-[var(--brand-primary)]/10 rounded-full"
          >
            Cancelar
          </Button>
          <Button
            onClick={handleSave}
            disabled={saving}
            className="flex-1 text-white font-bold rounded-full"
            style={{ background: 'linear-gradient(135deg, var(--brand-primary), #00F0FF)' }}
          >
            <FaSave className="mr-2" /> {saving ? 'Guardando...' : 'Guardar Entreno'}
          </Button>
        </div>
      </div>

      {/* MODAL DE SELECCIÓN DE EJERCICIOS */}
      {showExercisePicker && (
        <div className="fixed inset-0 bg-black/70 flex items-center justify-center z-50 p-4">
          <div className="rounded-2xl w-full max-w-2xl max-h-[80vh] overflow-hidden shadow-2xl" style={{ backgroundColor: '#111111', border: '1px solid rgba(255,255,255,0.1)' }}>
            {/* Header del modal */}
            <div className="text-white p-4 flex items-center justify-between" style={{ background: 'linear-gradient(135deg, var(--brand-primary), #00F0FF)' }}>
              <h3 className="text-xl font-poppins font-bold uppercase">Selecciona un Ejercicio</h3>
              <button
                onClick={() => setShowExercisePicker(false)}
                className="text-white hover:bg-white/20 rounded-full w-8 h-8 flex items-center justify-center transition-colors"
              >
                ✕
              </button>
            </div>

            {/* Buscador */}
            <div className="p-4 border-b" style={{ borderColor: 'rgba(255,255,255,0.1)' }}>
              <Input
                type="text"
                placeholder="Buscar ejercicio..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                className="w-full bg-white/10 border-white/20 text-white placeholder:text-gray-500"
                autoFocus
              />
            </div>

            {/* Lista de ejercicios por categoría */}
            <div className="overflow-y-auto max-h-[calc(80vh-180px)] p-4">
              {['chest', 'back', 'legs', 'shoulders', 'arms', 'core'].map(category => {
                const categoryExercises = filteredExercises.filter(ex => ex.category === category);
                const categoryLabel = {
                  chest: '💪 PECHO',
                  back: '🔙 ESPALDA',
                  legs: '🦵 PIERNAS',
                  shoulders: '💪 HOMBROS',
                  arms: '💪 BRAZOS',
                  core: '🔥 CORE'
                };

                if (categoryExercises.length === 0) return null;

                return (
                  <div key={category} className="mb-6">
                    <h4 className="font-poppins font-bold text-sm text-[#00F0FF] mb-2 uppercase">
                      {categoryLabel[category]}
                    </h4>
                    <div className="space-y-1">
                      {categoryExercises.map((ex, idx) => (
                        <button
                          key={idx}
                          onClick={() => selectExercise(ex.name)}
                          className="w-full text-left p-3 rounded-lg transition-colors border border-transparent hover:border-[var(--brand-primary)] font-medium text-white"
                          style={{ backgroundColor: 'rgba(255,255,255,0.05)' }}
                          onMouseEnter={(e) => e.currentTarget.style.backgroundColor = 'rgba(var(--brand-primary-glow),0.1)'}
                          onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'rgba(255,255,255,0.05)'}
                        >
                          {ex.name}
                        </button>
                      ))}
                    </div>
                  </div>
                );
              })}

              {filteredExercises.length === 0 && (
                <div className="text-center py-12 text-gray-400">
                  <p className="text-lg mb-2">No se encontraron ejercicios</p>
                  <p className="text-sm">Intenta con otro término de búsqueda</p>
                </div>
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default NewWorkout;